/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import isEmpty from 'lodash/isEmpty';

// This is needed to compensate for fetch's lack of url parameter management without string interpolation
export function urlWithParams(urlString, params = {}) {
    let searchParams = '';
    Object.keys(params).forEach((key) => {
        let sep = '';
        if (searchParams !== '') {
            sep = '&';
        }
        if (params[key] || params[key] === 0) {
            const val = params[key];
            if (!isEmpty(val) || val === 0) {
                if (Array.isArray(val)) {
                    val.forEach((v) => {
                        if (searchParams !== '') {
                            sep = '&';
                        }
                        searchParams = `${searchParams + sep + key}=${encodeURIComponent(v)}`;
                    });
                } else {
                    searchParams = `${searchParams + sep + key}=${encodeURIComponent(val)}`;
                }
            }
        }
    });
    let ret = urlString;
    if (!isEmpty(searchParams)) {
        ret = `${ret}?${searchParams}`;
    }
    return ret;
}

export const convertToDegrees = (decimal, isLongitude) => {
    const abs = Math.abs(decimal);
    const d = Math.floor(abs);
    const minfloat = (abs - d) * 60;
    const m = Math.floor(minfloat);
    const secfloat = (minfloat - m) * 60;
    const s = secfloat.toFixed(4);

    let cardinalPos = 'N';
    let cardinalNeg = 'S';

    if (isLongitude) {
        cardinalPos = 'E';
        cardinalNeg = 'W';
    }

    let cardinal = cardinalPos;
    if (decimal < 0) {
        cardinal = cardinalNeg;
    }

    return `${d}° ${m}' ${s}" ${cardinal}`;
};
